<template>
  <Menu theme="dark" ref="menus" :accordion="true" active-name="1" width="auto" @on-select="activePage">
    <Submenu v-for="(menu, index) in mockMenus" :key="menu.name" :name="menu.project">
      <template slot="title">
        {{menu.name}}
      </template>
      <MenuItem v-for="(subMenu, subIndex) in menu.child" :key="subMenu.name" :name="subMenu.action">
        {{subMenu.name}}
      </MenuItem>
    </Submenu>
  </Menu>
</template>

<script>
import mockMenus from '../mock/menus'

export default {
  data () {
    return {
      mockMenus
    }
  },
  methods: {
    activePage(name) {
      console.info(name)
      let project = this.$refs.menus.openNames[0];
      let currMenuItem = this.getCurrMenuItem(project, name);
      let path = [];
      // TODO: 目前匹配已完成的page
      switch(currMenuItem.action) {
        case "advertList":
          path = ['#/advert/list', `#/${currMenuItem.project}/${currMenuItem.url}`];
          break;
        case "homeHotCity":
          path = ['#/advert/hotCity', `#/${currMenuItem.project}/${currMenuItem.url}`];
          break;
        case "recommendRoom":
          path = ['#/advert/recommendRoom', `#/${currMenuItem.project}/${currMenuItem.url}`];
          break;
      }
      if (path.length==0) return;
      if (this.$router) {
        // 新OMS跳转
        window.location.href = path[0];
      } else {
        // 旧OMS跳转
        window.location.href = path[1];
      }
      // window.location.reload();
    },
    getCurrMenuItem(project, action) {
      for (let i=0; i<this.mockMenus.length; i++) {
        let menu = this.mockMenus[i];
        if (menu.project == project) {
          let subMenuArr = menu.child
          for (let j=0; j<subMenuArr.length; j++) {
            let menuItem = subMenuArr[j];
            if (menuItem.action == action) {
              return menuItem;
            }
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menus.vue